module.exports = __webpack_public_path__ + "img/promo_pc.dee1b86b.png";